import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize, Observable, tap } from 'rxjs';
import { Helps } from 'src/app/libs/helps';
import { SpinnerService } from 'src/app/services/spinner.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService, private toast: ToastrService, private router: Router, private helps: Helps) { }
  
  private pollingUrls: string[] = []; // Agrega las URL de las solicitudes de polling aquí

  // Nueva funcionalidad: Lista blanca de URLs que no usan spinner
  private noSpinnerUrls: string[] = [
    'admin/facility/paginatex/:page/:limit',
    'security-center/logbook',
    'security-center/images/temp',
    'security-center/incidents/by_entity/logbook_entries/:id'
  ];

  private isPollingRequest(req: HttpRequest<any>): boolean {
    return this.pollingUrls.some(url => req.url.includes(url));
  }

  // Nueva funcionalidad: Verificar si la request está en la lista blanca
  private isNoSpinnerRequest(req: HttpRequest<any>): boolean {
    const url = new URL(req.url, environment?.baseApiUrl || window.location.origin);
    let path = url.pathname;

    // Eliminar la barra inicial si existe para normalizar el formato
    if (path.startsWith('/')) {
      path = path.substring(1);
    }
    
    for (const route of this.noSpinnerUrls) {
      // Para rutas con parámetros dinámicos
      if (route.includes(':')) {
        // Convertir la ruta con parámetros en un patrón regex
        const patternString = route
          .replace(/\//g, '\\/') // Escapar las barras
          .replace(/:\w+/g, '[^\\/]+'); // Reemplazar :param con un patrón para cualquier valor
        
        const regex = new RegExp(`^${patternString}$`);
        
        if (regex.test(path)) {
          return true;
        }
      }
      // Para rutas estáticas
      else if (path.includes(route)) {
        return true;
      }
    }
    
    return false;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isPollingRequest = this.isPollingRequest(req);
    const isNoSpinnerRequest = this.isNoSpinnerRequest(req); // Nueva verificación

    // Mostrar spinner solo si NO es polling request Y NO está en lista blanca
    if (!isPollingRequest && !isNoSpinnerRequest) {
      this.spinnerService.show();
    }

    var updatedReq = req.clone({ url: req.url });
    if (sessionStorage.getItem('token') != null) {
      const token = this.helps.getToken()?.token;
      updatedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        },
        url: req.url + "?uid=" + this.helps.getToken()?.id
      });
    }

    return next.handle(updatedReq).pipe(
      tap(
        (event: HttpEvent<Response>) => {
          let results = event as any;
          if (results.status) {
            this.spinnerService.hide();
          }
        },
        (err: any) => {
          if (err.status == 500) {
            this.toast.error(
              'Tenemos un error en la comunicación con el servidor',
              'Lo sentimos'
            );
          }
          this.spinnerService.hide();
          if (err.status === 401) {
            this.router.navigate(['/login']);
          }
        }
      )
    );
  }
}